export default "__VITE_PUBLIC_ASSET__61d3ef1c__"